import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-fleetdiag-indicators',
  templateUrl: './fleetdiag-indicators.component.html',
  styleUrls: ['./fleetdiag-indicators.component.css', '../../fleetdiag-dashboard-pro.component.scss']
})
export class FleetdiagIndicatorsComponent implements OnInit {

  menuItems = [
    { label: 'نمای کلی', route: 'overview', icon: 'fa-dashboard' },
    { label: 'شاخص آلایندگی ‌لحظه‌ای', route: 'health-report', icon: 'fa-cloud' },
    { label: 'شاخص آلایندگی در زمان', route: 'pollution-index-chart', icon: 'fa-line-chart' },
    { label: 'شاخص سلامت موتور', route: 'engine-health-index', icon: 'fa-cogs' },
    { label: 'کیفیت احتراق', route: 'combustion-quality', icon: 'fa-fire' },
    { label: 'مصرف سوخت', route: 'fuel-efficienc', icon: 'fa-tint' },
    { label: 'ورودی هوا', route: 'air-intake-health', icon: 'fa-filter' },
    { label: 'سیستم الکتریکی', route: 'electrical-system-health', icon: 'fa-bolt' },
    { label: 'ریسک خرابی', route: 'failure-risk', icon: 'fa-exclamation-triangle' },
  ];


  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }


}
